module.exports = __webpack_public_path__ + "img/logo-white.cec9ec41.png";